import { Injectable } from '@angular/core';

import { setInitialStoreState } from '../../../../../common';
import { PlantExternalIdsFacade } from './plant-external-ids.facade';

@Injectable({
  providedIn: 'root',
})
export class PlantExternalIdsGuard  {
  constructor(private plantExternalIdsFacade: PlantExternalIdsFacade) {}

  canDeactivate(): boolean {
    return setInitialStoreState(this.plantExternalIdsFacade);
  }
}
